module.exports = __webpack_public_path__ + "static/media/check-circle.5c68f249.svg";